import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6af53610"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-box-container" }
const _hoisted_2 = ["alt", "src"]



  
export default /*#__PURE__*/_defineComponent({
  __name: 'ContactBox',
  props: {
    icon: null,
    alt: null
  },
  setup(__props: any) {

const props = __props as {
    icon: string;
    alt?: string;
  };

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "icon-small iconBG color-orange",
      alt: props.alt ? props.alt : 'icon',
      src: require(`../assets/media/icons/${props.icon}`)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "text")
    ])
  ]))
}
}

})